export default "__VITE_ASSET__WfYN5HCy__"